import { unwrapApiPayload } from "./mapUserActivityGraph";

const DEFAULT_BAR = {
  dataKey: "shareCount",
  color: "#5c308d",
  name: "Shares",
};

function resolvePoints(payload) {
  if (!payload) return null;
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload.data)) return payload.data;
  if (Array.isArray(payload.analytics)) return payload.analytics;
  if (Array.isArray(payload.dailyShareAnalytics)) return payload.dailyShareAnalytics;
  return null;
}

function normalizePoints(points) {
  return points.map((point) => ({
    ...point,
    shareCount: Number(point.shareCount) || 0,
  }));
}

export function mapShareAnalyticsGraph(response, defaults = {}) {
  const payload = unwrapApiPayload(response);
  const rawPoints = resolvePoints(payload);

  if (!rawPoints?.length) return null;

  const data = normalizePoints(rawPoints);

  return {
    data,
    bars: defaults.bars?.length
      ? defaults.bars
      : [
          {
            dataKey: DEFAULT_BAR.dataKey,
            color: DEFAULT_BAR.color,
            name: DEFAULT_BAR.name,
          },
        ],
    xKey: defaults.xKey ?? "day",
    title: payload?.title ?? defaults.title ?? "Share Analytics",
    subtitle:
      payload?.subtitle ??
      defaults.subtitle ??
      "Weekly share distribution",
    height: defaults.height ?? 300,
    showGrid: defaults.showGrid ?? true,
    showLegend: defaults.showLegend ?? false,
  };
}
